import joinFlow from '~/middleware/join-flow'
import promotionGuard from '~/middleware/promotion-guard'
import roleGuard from '~/middleware/role-guard'

// Nuxt loads a page's named middleware with a dynamic import when the route resolves,
// and the first navigation has to resolve before the app mounts: on a page that names
// one, hydration waited for that chunk's round trip, which on a busy link queued behind
// the page's images (category pages: mount ~1.1 s later in the lab once the chunk was no
// longer prefetched from the head, server/plugins/deferredPrefetch.ts). The router looks
// in the runtime registry before importing, so registering them here bundles the three
// (~2 KB) with the app and no navigation waits for one.
export const NAMED_MIDDLEWARE = {
  'join-flow': joinFlow,
  'promotion-guard': promotionGuard,
  'role-guard': roleGuard
}

export default defineNuxtPlugin({
  name: 'named-middleware',
  // Default order, so after the router plugin (enforce: 'pre'), which creates the registry
  // addRouteMiddleware writes to. The first navigation that runs middleware starts in
  // app:created, after every plugin's setup, so it already finds them.
  setup () {
    for (const [name, middleware] of Object.entries(NAMED_MIDDLEWARE)) {
      addRouteMiddleware(name, middleware)
    }
  }
})
